import * as yup from 'yup';
// const passwordRule = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{5,16}$/;
// const passwordRule = /^(?=.*[a-z])(?=.*\d)[a-z\d]{6}$/;
export const loginSchema = yup.object().shape({
    email:yup.string().email('Please enter a valid email').required('Required'),
  
    password: yup
        .string()
    // .matches(passwordRule, "Password must contain at least one digit and be 6 characters long")
        .required('Required'),
});
